/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

export async function loadFonts () {
  const webFontLoader = await import(/* webpackChunkName: "webfontloader" */'webfontloader')

  webFontLoader.load({
    custom: {
      families: ['Roboto:400,700', 'Linhai:400'],
      urls: ['/assets/fonts/Roboto.css', '/assets/fonts/Linhai.css']
    },
  })
}
